import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nigi_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const invite = localStorage.getItem("nigi_invite_token");
  if (invite && (config.url || "").startsWith("/public")) config.headers["X-Invite-Token"] = invite;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    if (err.response?.status === 401 && url.startsWith("/admin")) {
      localStorage.removeItem("nigi_admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const savedInvite = () => (typeof window !== "undefined" ? localStorage.getItem("nigi_invite_token") : null);

export const evDate = (s) => {
  const [y, m, d] = (s || "").split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

export const absFile = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return urlOrPath;
};
